import gql from 'graphql-tag';

export const GET_PROFILE_INFO = gql`
  query Author($USERNAME: ID!, $LIMIT: Int) {
    author(id: $USERNAME) {
      id
      name
      alternateName
      certified
      prenom
      mobile
      mail
      image
      imageProfil
      posts(limit: $LIMIT) {
        total
      }
      favorites
    }
  }
`;
export const GET_PROFILE_POST = gql`
  query Author($USERNAME: ID!, $LIMIT: Int) {
    author(id: $USERNAME) {
      id
      favorites
      posts(limit: $LIMIT) {
        total
      }
    }
  }
`;
export const GET_AUTHOR_INFO = gql`
  query Author($USERNAME: ID!) {
    author(id: $USERNAME) {
      id
      name
      alternateName
      certified
      prenom
      disableNotif
      image
      imageProfil
      favorites
      role
      boost
    }
  }
`;

export const GET_PUBLISHED_POST = gql`
  query Author($USERNAME: ID!, $LIMIT: Int, $page: Int) {
    author(id: $USERNAME) {
      id
      posts(limit: $LIMIT, page: $page) {
        data {
          sid
          additionalType
          certified
          title
          id
          media
          photos
          price
          category
          town
          createdAt
          updatedAt
          userId
          stats
        }
        total
      }
    }
  }
`;

export const GET_RELATED_REVIEWS = gql`
  query Author($USERNAME: ID!) {
    author(id: $USERNAME) {
      id
      rating {
        data {
          global
          communication
          punctuality
          quality
        }
      }
      reviews {
        data {
          creatorAlternateName
          creatorCertified
          id
          title
          message
          global
          createdAt
          updatedAt
        }
      }
    }
  }
`;

export const GET_FAVOURITE_POST = gql`
  query Author($USERNAME: ID!, $LIMIT: Int, $page: Int) {
    author(id: $USERNAME) {
      id
      favourite(limit: $LIMIT, page: $page) {
        data {
          sid
          id
          title
          media
          price
          category
          town
          createdAt
        }
        total
      }
    }
  }
`;
